import { render, staticRenderFns } from "./AskPriceDesc.vue?vue&type=template&id=7c7e92ff&scoped=true&"
var script = {}
import style0 from "./AskPriceDesc.vue?vue&type=style&index=0&id=7c7e92ff&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c7e92ff",
  null
  
)

export default component.exports